import { useEffect, useRef } from "react";
import { media } from "../data/siteData";

export const ScrollVideoStage = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return undefined;

    const playVideo = () => {
      video.muted = true;
      video.play().catch(() => {
        // If a browser blocks autoplay, controls remain available.
      });
    };

    video.load();
    playVideo();
    video.addEventListener("loadedmetadata", playVideo);
    video.addEventListener("canplay", playVideo);

    return () => {
      video.removeEventListener("loadedmetadata", playVideo);
      video.removeEventListener("canplay", playVideo);
    };
  }, []);

  return (
    <section data-testid="home-video-section" className="video-showcase-shell relative px-5 py-24 md:px-10 md:py-32">
      <div className="mx-auto grid max-w-7xl gap-10 lg:grid-cols-[0.85fr_1.15fr]">
        <div data-testid="video-copy-panel" className="h-fit self-center">
          <p data-testid="video-kicker" className="text-xs font-bold uppercase tracking-[0.3em] text-[#FFC059]">Drone cam</p>
          <h2 data-testid="video-title" className="mt-5 font-heading text-4xl font-black leading-none tracking-tight text-white sm:text-5xl">
            A moving window into Kannur’s coast.
          </h2>
          <p data-testid="video-description" className="mt-6 max-w-xl text-base leading-8 text-slate-400">
            Aerial views of our home break — warm water, patient coaching, local people, and the kind of golden mornings that make you stay longer than planned.
          </p>

          <div data-testid="video-note-card" className="mt-9 border border-white/10 bg-[#131B2F]/80 p-6 backdrop-blur">
            <p className="text-xs font-bold uppercase tracking-[0.24em] text-[#FF5E3A]">North Kerala surf energy</p>
            <p className="mt-3 text-sm leading-7 text-slate-300">Kannur Surf Club brings together surf lessons, kite sessions, beach community, and stays that keep you close to the coastline.</p>
          </div>
        </div>

        <div data-testid="video-frame" className="self-center">
          <div className="relative overflow-hidden rounded-[2rem] border border-white/10 bg-[#080C16] p-3 shadow-2xl shadow-black/40">
            <video
              ref={videoRef}
              data-testid="home-video-player"
              poster={media.scrollVideoPoster}
              muted
              autoPlay
              loop
              playsInline
              preload="metadata"
              aria-label="Drone cam: aerial view of the Kannur coastline"
              className="aspect-[16/9] w-full rounded-[1.5rem] object-cover object-center"
            >
              <source data-testid="home-video-webm-source" src={media.scrollVideoWebm} type="video/webm" />
              <source data-testid="home-video-mp4-source" src={media.scrollVideo} type="video/mp4" />
              Your browser does not support embedded video.
            </video>
          </div>
        </div>
      </div>
    </section>
  );
};
